function initGiftNoteBlock() {
  const container = document.querySelector('.regalo-jonytips');
  if (!container || container.dataset.initialized === "true") return;

  container.dataset.initialized = "true";

  const header = container.querySelector('.regalo-jonytips__header');
  const toggleBtn = container.querySelector('.regalo-jonytips__toggle');
  const content = container.querySelector('.regalo-jonytips__content');
  const form = container.querySelector('#giftNoteForm');
  const inputs = form?.querySelectorAll('.regalo-jonytips__input, .regalo-jonytips__textarea') || [];
  const autoSaveStatus = container.querySelector('#autoSaveStatus');
  const autoSaveText = container.querySelector('#autoSaveText');
  const successMessage = container.querySelector('#regalo-jonytips-success');

  if (!form) return;

  let autoSaveTimeout;
  let lastSavedData = {};
  const AUTOSAVE_DELAY = 1500;

  // --- Accordion ---
  header.addEventListener('click', () => {
    const isOpen = content.classList.contains('is-open');
    content.classList.toggle('is-open', !isOpen);
    header.classList.toggle('is-open', !isOpen);
    toggleBtn.setAttribute('aria-expanded', String(!isOpen));
  });

  function updateInputStates() {
    inputs.forEach(input => {
      input.classList.toggle('has-value', input.value.trim() !== '');
    });
  }

  // --- Load saved ---
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const attrs = cart.attributes || {};
      form.querySelector('#from').value = attrs['De'] || '';
      form.querySelector('#to').value = attrs['Para'] || '';
      form.querySelector('#message').value = attrs['Mensaje'] || '';
      updateInputStates();
      lastSavedData = {
        De: form.querySelector('#from').value,
        Para: form.querySelector('#to').value,
        Mensaje: form.querySelector('#message').value
      };
    });

  // --- AutoSave ---
  function autoSave() {
    const data = {
      De: form.querySelector('#from').value.trim(),
      Para: form.querySelector('#to').value.trim(),
      Mensaje: form.querySelector('#message').value.trim()
    };
    if (JSON.stringify(data) === JSON.stringify(lastSavedData)) return;
    if (!data.De && !data.Para && !data.Mensaje) return;

    autoSaveStatus.classList.add('is-visible', 'is-saving');
    autoSaveText.textContent = 'Guardando...';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: data })
    })
      .then(r => r.json())
      .then(() => {
        autoSaveStatus.classList.remove('is-saving');
        autoSaveStatus.classList.add('is-success');
        autoSaveText.textContent = 'Guardado automáticamente';
        lastSavedData = data;
        setTimeout(() => autoSaveStatus.classList.remove('is-visible', 'is-success'), 2500);
      })
      .catch(() => {
        autoSaveText.textContent = 'Error al guardar';
        setTimeout(() => autoSaveStatus.classList.remove('is-visible'), 2500);
      });
  }

  inputs.forEach(i => i.addEventListener('input', () => {
    updateInputStates();
    clearTimeout(autoSaveTimeout);
    autoSaveTimeout = setTimeout(autoSave, AUTOSAVE_DELAY);
  }));

  form.addEventListener('submit', e => e.preventDefault());
}

/* --- Controlador universal --- */
function waitForGiftNote() {
  // Reintenta hasta que el bloque cart-subtotal esté montado
  const hasCartSubtotal = document.querySelector('#AjaxCartSubtotal');
  const hasGiftBlock = document.querySelector('.regalo-jonytips');
  if (hasCartSubtotal && hasGiftBlock) {
    initGiftNoteBlock();
  } else {
    // vuelve a intentar en 300ms (solo unas pocas veces)
    setTimeout(waitForGiftNote, 300);
  }
}

// Drawer (funciona normal)
document.addEventListener('cart:updated', initGiftNoteBlock);
document.addEventListener('shopify:section:load', initGiftNoteBlock);

// Main cart
document.addEventListener('DOMContentLoaded', () => {
  waitForGiftNote();

  // fallback si Turbo reemplaza #AjaxCartSubtotal dinámicamente
  const subtotal = document.querySelector('#AjaxCartSubtotal');
  if (subtotal) {
    const observer = new MutationObserver(() => {
      if (document.querySelector('.regalo-jonytips:not([data-initialized])')) {
        initGiftNoteBlock();
      }
    });
    observer.observe(subtotal, { childList: true, subtree: true });
  }
});
